import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import Component from '../Component';
/**
 * The vr-mode-ui component allows disabling of UI such as an
 * Enter VR button, compatibility modal, and orientation modal for mobile.
 * The vr-mode-ui component applies only to the [`<a-scene>` element](https://aframe.io/docs/1.3.0/core/scene.html).
 * If we wish to simply toggle the UI, use CSS instead.
 *
 * @see https://aframe.io/docs/1.3.0/components/vr-mode-ui.html
 */

export var VrModeUI = /*#__PURE__*/function (_Component) {
  _inheritsLoose(VrModeUI, _Component);

  function VrModeUI() {
    return _Component.apply(this, arguments) || this;
  }

  return VrModeUI;
}(Component);